// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ajcb2Tpl {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.JssU32Qk {
  padding: 3px 8px;
  background: rgba(22, 33, 62, 0.9);
  color: #4ecca3;
  border: 1px solid #4ecca3;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.JssU32Qk:hover:not(:disabled) {
  background: rgba(78, 204, 163, 0.1);
}

.JssU32Qk:disabled {
  opacity: 0.6;
  cursor: default;
}

.JssU32Qk._JgwuZjk {
  background: rgba(78, 204, 163, 0.15);
  border-color: #4ecca3;
}

.ESDUud30 {
  font-size: 10px;
  color: #888;
  word-break: break-all;
  max-width: 100px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Share.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B","sourcesContent":[".shareContainer {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.shareBtn {\n  padding: 3px 8px;\n  background: rgba(22, 33, 62, 0.9);\n  color: #4ecca3;\n  border: 1px solid #4ecca3;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.shareBtn:hover:not(:disabled) {\n  background: rgba(78, 204, 163, 0.1);\n}\n\n.shareBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.shareBtn.copied {\n  background: rgba(78, 204, 163, 0.15);\n  border-color: #4ecca3;\n}\n\n.shareUrl {\n  font-size: 10px;\n  color: #888;\n  word-break: break-all;\n  max-width: 100px;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shareContainer": `Ajcb2Tpl`,
	"shareBtn": `JssU32Qk`,
	"copied": `_JgwuZjk`,
	"shareUrl": `ESDUud30`
};
export default ___CSS_LOADER_EXPORT___;
